/**
 * 707DTF Theme JavaScript
 * Keep this file lean — add only high-value interactivity
 */

var __707AuthPopupTimer = null;
var __707AuthPopupRef = null;

/** True when this window is the auth popup that should self-close after Shopify login. */
function is707AuthPopupWindow() {
  try {
    if (window.name === '707dtf_shopify_login') return true;
  } catch (e) {}
  try {
    var q = new URLSearchParams(window.location.search || '');
    if (q.get('auth_popup') === '1') return true;
  } catch (e2) {}
  try {
    if (sessionStorage.getItem('707_auth_popup') === '1') return true;
  } catch (e3) {}
  return false;
}

/**
 * If we are the login popup returned to the storefront, notify opener and close.
 * Runs immediately (not waiting for DOM) so the popup doesn't stay open.
 */
function close707AuthPopupIfChild() {
  try {
    if (!window.opener || window.opener.closed) return false;
    if (!is707AuthPopupWindow()) return false;

    var payload = {
      type: '707-auth-complete',
      href: String(window.location.href || ''),
      path: String(window.location.pathname || '/')
    };
    try {
      window.opener.postMessage(payload, window.location.origin);
    } catch (e1) {
      try {
        window.opener.postMessage(payload, '*');
      } catch (e2) {}
    }
    try {
      if (typeof window.opener.__707onAuthComplete === 'function') {
        window.opener.__707onAuthComplete(payload);
      }
    } catch (e3) {}
    try {
      window.opener.focus();
    } catch (e4) {}

    // Clear popup flag so a full navigation later is normal
    try {
      sessionStorage.removeItem('707_auth_popup');
    } catch (e5) {}

    setTimeout(function () {
      try {
        window.close();
      } catch (e6) {}
      // If the browser blocks close, bounce to a blank page
      try {
        if (!window.closed) {
          window.location.replace('about:blank');
        }
      } catch (e7) {}
    }, 50);
    return true;
  } catch (e) {
    return false;
  }
}

// Run ASAP when this file loads (popup return path)
try {
  close707AuthPopupIfChild();
} catch (eEarly) {}

/** Append auth_popup=1 so the return page knows it is the login child window. */
function with707AuthPopupFlag(returnUrl) {
  var raw = returnUrl || '/';
  try {
    var u = new URL(raw, window.location.origin);
    u.searchParams.set('auth_popup', '1');
    return u.pathname + u.search + (u.hash || '');
  } catch (e) {
    if (String(raw).indexOf('auth_popup=1') >= 0) return raw;
    return raw + (String(raw).indexOf('?') >= 0 ? '&' : '?') + 'auth_popup=1';
  }
}

/** Strip auth_popup from URL for final navigation after login. */
function strip707AuthPopupFlag(returnUrl) {
  var raw = returnUrl || '/';
  try {
    var u = new URL(raw, window.location.origin);
    u.searchParams.delete('auth_popup');
    var q = u.searchParams.toString();
    return u.pathname + (q ? '?' + q : '') + (u.hash || '');
  } catch (e) {
    return String(raw)
      .replace(/([?&])auth_popup=1&?/, '$1')
      .replace(/[?&]$/, '');
  }
}

/**
 * Build Shopify Customer Accounts login URL with return_to.
 * Store uses New Customer Accounts (account.707dtf.com) — not classic password forms.
 */
function build707ShopifyLoginUrl(returnUrl) {
  const auth = window.__707_AUTH__ || {};
  const overlay = document.getElementById('customerAuthOverlay');
  let base =
    (overlay && overlay.getAttribute('data-shopify-login')) ||
    auth.storefrontLoginWithReturn ||
    auth.storefrontLoginUrl ||
    auth.loginUrl ||
    '/customer_authentication/login';
  // Popup must return to a same-origin page that can close itself
  const ret = with707AuthPopupFlag(
    returnUrl ||
      auth.returnTo ||
      (overlay && overlay.getAttribute('data-default-return')) ||
      window.location.pathname + window.location.search ||
      '/'
  );
  try {
    const u = new URL(base, window.location.origin);
    u.searchParams.set('return_to', ret);
    if (u.origin === window.location.origin || base.indexOf('http') !== 0) {
      return u.pathname + u.search;
    }
    return u.toString();
  } catch (e) {
    const sep = base.indexOf('?') >= 0 ? '&' : '?';
    return base + sep + 'return_to=' + encodeURIComponent(ret);
  }
}

/** Parent window: finish auth after popup reports success or returns to our origin. */
function finish707AuthFromPopup(detail) {
  detail = detail || {};
  if (__707AuthPopupTimer) {
    try {
      clearInterval(__707AuthPopupTimer);
    } catch (e) {}
    __707AuthPopupTimer = null;
  }
  __707AuthPopupRef = null;

  try {
    close707AuthDialog();
  } catch (e2) {}

  var finalUrl = null;
  try {
    finalUrl = sessionStorage.getItem('707_auth_final');
    sessionStorage.removeItem('707_auth_final');
    sessionStorage.removeItem('707_auth_popup');
  } catch (e3) {}

  if (!finalUrl && detail.href) {
    try {
      finalUrl = strip707AuthPopupFlag(detail.href);
    } catch (e4) {}
  }
  if (!finalUrl) {
    finalUrl = strip707AuthPopupFlag(
      window.location.pathname + window.location.search
    );
  }

  try {
    var dest = new URL(finalUrl, window.location.origin);
    // Always reload to pick up the customer session cookie
    if (
      dest.pathname === window.location.pathname &&
      dest.search.replace(/[?&]auth_popup=1/, '') ===
        window.location.search.replace(/[?&]auth_popup=1/, '')
    ) {
      window.location.reload();
    } else {
      window.location.assign(dest.pathname + dest.search + dest.hash);
    }
  } catch (e5) {
    window.location.reload();
  }
}

window.__707onAuthComplete = finish707AuthFromPopup;

// Parent listens for popup completion (works when child can postMessage)
try {
  window.addEventListener('message', function (ev) {
    try {
      if (!ev || !ev.data || ev.data.type !== '707-auth-complete') return;
      // Only trust same-origin storefront messages
      if (ev.origin && ev.origin !== window.location.origin) return;
      finish707AuthFromPopup(ev.data);
    } catch (e) {}
  });
} catch (eMsg) {}

/**
 * Open Shopify's official hosted sign-in (email OTP, Shop, social if enabled).
 * Prefer popup so the storefront dialog context remains; fall back to full navigation.
 * After login the popup returns with auth_popup=1, self-closes, and reloads the opener.
 */
function open707ShopifyLogin(returnUrl) {
  const intended =
    returnUrl ||
    (window.__707_AUTH__ && window.__707_AUTH__.returnTo) ||
    window.location.pathname + window.location.search ||
    '/';
  try {
    sessionStorage.setItem('707_auth_final', strip707AuthPopupFlag(intended));
    sessionStorage.setItem('707_auth_popup', '1');
  } catch (e0) {}

  const url = build707ShopifyLoginUrl(intended);
  let popup = null;
  try {
    popup = window.open(
      url,
      '707dtf_shopify_login',
      'width=480,height=740,menubar=no,toolbar=no,location=yes,status=no,scrollbars=yes,resizable=yes'
    );
  } catch (e) {
    popup = null;
  }
  if (!popup || popup.closed) {
    // Full-page fallback — still use auth_popup bridge then redirect
    window.location.href = url;
    return false;
  }

  __707AuthPopupRef = popup;
  if (__707AuthPopupTimer) {
    try {
      clearInterval(__707AuthPopupTimer);
    } catch (eClear) {}
  }

  const started = Date.now();
  __707AuthPopupTimer = setInterval(function () {
    var ref = __707AuthPopupRef;
    if (!ref) {
      clearInterval(__707AuthPopupTimer);
      __707AuthPopupTimer = null;
      return;
    }

    var closed = false;
    try {
      closed = ref.closed;
    } catch (e2) {
      closed = true;
    }

    if (closed) {
      clearInterval(__707AuthPopupTimer);
      __707AuthPopupTimer = null;
      __707AuthPopupRef = null;
      // User finished (child should have posted message; if not, still refresh)
      finish707AuthFromPopup({});
      return;
    }

    // When Shopify redirects popup back to our storefront, close it from the parent
    try {
      var href = ref.location && ref.location.href;
      var origin = ref.location && ref.location.origin;
      if (origin && origin === window.location.origin && href) {
        try {
          ref.postMessage({ type: '707-auth-close-self' }, origin);
        } catch (e3) {}
        try {
          ref.close();
        } catch (e4) {}
        clearInterval(__707AuthPopupTimer);
        __707AuthPopupTimer = null;
        __707AuthPopupRef = null;
        finish707AuthFromPopup({ href: href });
        return;
      }
    } catch (eCross) {
      // Still on account.707dtf.com / cross-origin — keep waiting
    }

    if (Date.now() - started > 15 * 60 * 1000) {
      clearInterval(__707AuthPopupTimer);
      __707AuthPopupTimer = null;
      try {
        ref.close();
      } catch (e5) {}
      __707AuthPopupRef = null;
    }
  }, 400);

  try {
    popup.focus();
  } catch (e4) {}
  return true;
}

/** Open themed sign-in dialog (Shop button + Shopify hosted options). */
function open707AuthDialog(opts) {
  opts = opts || {};
  const overlay = document.getElementById('customerAuthOverlay');
  if (!overlay) {
    open707ShopifyLogin(opts.returnUrl);
    return false;
  }

  const returnUrl =
    opts.returnUrl ||
    overlay.getAttribute('data-default-return') ||
    window.location.pathname + window.location.search;

  overlay.setAttribute('data-pending-return', returnUrl);
  // Refresh data-shopify-login with this return target
  try {
    const href = build707ShopifyLoginUrl(returnUrl);
    overlay.setAttribute('data-shopify-login', href);
    const emailBtn = document.getElementById('customerAuthContinueEmail');
    const allBtn = document.getElementById('customerAuthAllOptions');
    if (emailBtn) emailBtn.setAttribute('data-shopify-login', href);
    if (allBtn) allBtn.setAttribute('data-shopify-login', href);
  } catch (e) {}

  const title = document.getElementById('customerAuthTitle');
  const sub = document.getElementById('customerAuthSub');
  if (title) {
    title.textContent =
      opts.title ||
      (opts.purpose === 'contact' ? 'Sign in to send a message' : 'Sign in to continue');
  }
  if (sub) {
    sub.textContent =
      opts.message ||
      (opts.purpose === 'contact'
        ? 'Sign in with Shop or email — same options as Shopify customer accounts.'
        : 'Sign in with Shop or email to use builders. Same options as Shopify accounts.');
  }

  overlay.classList.add('show');
  overlay.setAttribute('aria-hidden', 'false');
  document.body.classList.add('customer-auth-open');
  try {
    const panel = overlay.querySelector('.customer-auth-panel');
    if (panel) panel.focus();
  } catch (e) {}
  return true;
}

function close707AuthDialog() {
  const overlay = document.getElementById('customerAuthOverlay');
  if (!overlay) return;
  overlay.classList.remove('show');
  overlay.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('customer-auth-open');
}

/** Require store account — opens dialog instead of full login page */
function require707Account(e, opts) {
  const auth = window.__707_AUTH__ || {};
  if (!auth.required || auth.loggedIn) return false;
  if (e) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
  }
  open707AuthDialog(opts || {});
  return true;
}

window.open707AuthDialog = open707AuthDialog;
window.close707AuthDialog = close707AuthDialog;
window.require707Account = require707Account;
window.open707ShopifyLogin = open707ShopifyLogin;
window.build707ShopifyLoginUrl = build707ShopifyLoginUrl;

document.addEventListener('DOMContentLoaded', () => {
  // Auth dialog wiring — Shopify New Customer Accounts options
  const overlay = document.getElementById('customerAuthOverlay');
  if (overlay) {
    const closeBtn = document.getElementById('customerAuthClose');
    if (closeBtn) closeBtn.addEventListener('click', close707AuthDialog);
    const cancelBtn = document.getElementById('customerAuthCancelLogin');
    if (cancelBtn) cancelBtn.addEventListener('click', close707AuthDialog);

    const launchShopify = (btn) => {
      const ret =
        overlay.getAttribute('data-pending-return') ||
        overlay.getAttribute('data-default-return') ||
        undefined;
      const url =
        (btn && btn.getAttribute('data-shopify-login')) ||
        overlay.getAttribute('data-shopify-login');
      if (url) {
        // Ensure return_to is current
        open707ShopifyLogin(ret);
      } else {
        open707ShopifyLogin(ret);
      }
    };

    const emailBtn = document.getElementById('customerAuthContinueEmail');
    if (emailBtn) {
      emailBtn.addEventListener('click', (e) => {
        e.preventDefault();
        launchShopify(emailBtn);
      });
    }
    const allBtn = document.getElementById('customerAuthAllOptions');
    if (allBtn) {
      allBtn.addEventListener('click', (e) => {
        e.preventDefault();
        launchShopify(allBtn);
      });
    }

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close707AuthDialog();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('show')) close707AuthDialog();
    });
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target && e.target.closest && e.target.closest('.js-open-auth-dialog');
    if (!openBtn) return;
    e.preventDefault();
    open707AuthDialog({
      returnUrl: openBtn.getAttribute('data-auth-return') || undefined,
      purpose: openBtn.getAttribute('data-auth-purpose') || undefined
    });
  });

  // Gate builder / transfer CTAs for guests → dialog
  const auth = window.__707_AUTH__ || {};
  if (auth.required && !auth.loggedIn) {
    const builderSelectors = [
      '.js-open-transfer-upload',
      '.js-open-gangsheet-builder',
      'a[href*="view=gsb"]',
      'a[href*="start=1"]',
      'a[href*="#open-transfer-upload"]',
      'a[href*="mode=transfer"]',
      '[data-auth-purpose="builder"]'
    ].join(',');
    document.addEventListener(
      'click',
      (e) => {
        const t = e.target && e.target.closest ? e.target.closest(builderSelectors) : null;
        if (!t) return;
        // Explicit open-auth buttons handle themselves
        if (t.classList.contains('js-open-auth-dialog')) return;
        const returnUrl =
          t.getAttribute('data-auth-return') ||
          t.getAttribute('href') ||
          window.location.pathname + window.location.search;
        // Don't treat #how-it-works style anchors as builder unless marked
        if (returnUrl.charAt(0) === '#' && returnUrl.indexOf('open-transfer') === -1) return;
        require707Account(e, {
          returnUrl: returnUrl === '#' || returnUrl.indexOf('#open-transfer') === 0
            ? window.location.pathname + window.location.search
            : returnUrl,
          purpose: t.getAttribute('data-auth-purpose') || 'builder',
          tab: 'login'
        });
      },
      true
    );
  }

  // Mobile nav hamburger toggle
  const navToggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-nav]');

  if (navToggle && nav) {
    navToggle.addEventListener('click', () => {
      nav.classList.toggle('is-open');
    });
  }

  // Mobile dropdown toggles (click to open submenus)
  const dropdownToggles = document.querySelectorAll('.nav-dropdown-toggle');

  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      // Only handle click behavior on mobile
      if (window.innerWidth <= 1024) {
        e.preventDefault();
        const parent = toggle.closest('.nav-dropdown');
        parent.classList.toggle('is-open');
      }
    });
  });

  // Close mobile nav when clicking a link
  const navLinks = document.querySelectorAll('.header__nav a');
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      if (nav) nav.classList.remove('is-open');
      // Close any open dropdowns
      document.querySelectorAll('.nav-dropdown').forEach(d => d.classList.remove('is-open'));
    });
  });

  // Cart quantity +/- buttons (submit the cart form to apply changes)
  const qtyButtons = document.querySelectorAll('.quantity-btn');
  qtyButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      const line = btn.getAttribute('data-line');
      const action = btn.getAttribute('data-action');
      if (!line || !action) return;

      const input = document.querySelector(`input[data-line="${line}"]`);
      if (!input) return;

      let value = parseInt(input.value, 10);
      if (isNaN(value)) value = 1;

      if (action === 'increment') {
        value = value + 1;
      } else if (action === 'decrement') {
        value = Math.max(1, value - 1);
      }

      input.value = value;

      // Submit the cart update form (full reload is acceptable for this custom cart)
      const cartForm = document.getElementById('cart-form');
      if (cartForm) {
        cartForm.submit();
      }
    });
  });

  // Auto-apply when user manually types/changes a quantity input (on blur or enter)
  const qtyInputs = document.querySelectorAll('#cart-form input[name="updates[]"]');
  qtyInputs.forEach(inp => {
    inp.addEventListener('change', () => {
      const cartForm = document.getElementById('cart-form');
      if (cartForm) cartForm.submit();
    });
  });

  console.log('%c[707DTF] Theme JS initialized', 'color:#666');

  // ---- Cart: poll server print jobs + attach Print file when ready ----
  (function initPrintJobCartPoller() {
    const path = (location.pathname || '').toLowerCase();
    if (path.indexOf('/cart') < 0) return;

    const apiBase = String(
      (window.__GSB_API_BASE__ || '')
    ).replace(/\/$/, '');
    if (!apiBase) return;

    async function cartJson() {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const r = await fetch(root + 'cart.js', { credentials: 'same-origin' });
      return r.json();
    }

    async function updateLineProps(key, qty, props) {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const res = await fetch(root + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: key, quantity: qty, properties: props })
      });
      return res.ok;
    }

    async function pollOnce() {
      let cart;
      try {
        cart = await cartJson();
      } catch (e) {
        return false;
      }
      const items = (cart && cart.items) || [];
      let anyProcessing = false;
      let updated = false;

      for (let i = 0; i < items.length; i++) {
        const it = items[i];
        const p = it.properties || {};
        const gsId = p._gangsheet_id || p.gangsheet_id || p._transfer_id || '';
        const status = String(
          p._print_status || p.print_status || ''
        ).toLowerCase();
        const gangProp = String(p._gangsheet || '');
        const hasReadyFile =
          status === 'ready' &&
          !!(p._print_file || p._file_url || p._gangsheet) &&
          gangProp !== 'processing' &&
          /^https?:\/\//i.test(gangProp || p._file_url || '');
        if (!gsId) continue;
        if (hasReadyFile) continue;
        anyProcessing = true;
        try {
          // 1) Prefer print-jobs status
          let fileUrl = '';
          let fileId = '';
          let fileName = '';
          const jr = await fetch(
            apiBase + '/api/707/print-jobs/' + encodeURIComponent(gsId),
            { mode: 'cors', credentials: 'omit' }
          );
          const job = await jr.json().catch(function () {
            return {};
          });
          if (job && job.ok && job.status === 'ready' && job.fileUrl) {
            fileUrl = String(job.fileUrl);
            fileId = String(job.fileId || job.id || '');
            fileName = String(job.fileName || '');
          }
          // 2) Stable URL probe: GET /api/files/print-{id}.png → 200 when ready
          if (!fileUrl) {
            const safe = String(gsId)
              .replace(/[^a-zA-Z0-9._-]/g, '_')
              .slice(0, 100);
            const stableName = 'print-' + safe + '.png';
            const stableUrl =
              apiBase + '/api/files/' + encodeURIComponent(stableName);
            try {
              const pr = await fetch(stableUrl, {
                method: 'GET',
                mode: 'cors',
                credentials: 'omit'
              });
              if (pr.ok && (pr.headers.get('content-type') || '').indexOf('image') >= 0) {
                fileUrl = stableUrl;
                fileName = stableName;
              }
            } catch (eProbe) {}
          }
          if (fileUrl) {
            const next = Object.assign({}, p, {
              _gangsheet: String(fileUrl).slice(0, 255),
              _file_url: String(fileUrl).slice(0, 255),
              _print_file: String(fileUrl).slice(0, 255),
              _file_id: String(fileId || '').slice(0, 120),
              _file_name: String(fileName || '').slice(0, 120),
              _print_status: 'ready'
            });
            try { delete next['Print file']; } catch (e0) {}
            try { delete next.file_url; } catch (e1) {}
            try { delete next.print_status; } catch (e2) {}
            try { delete next.Gangsheet; } catch (e3) {}
            const ok = await updateLineProps(it.key || it.id, it.quantity, next);
            if (ok) updated = true;
          }
        } catch (e) {
          console.warn('[707DTF] print job poll', e);
        }
      }
      if (updated) {
        // Refresh cart UI
        location.reload();
        return true;
      }
      return anyProcessing;
    }

    let tries = 0;
    const maxTries = 40; // ~2 min at 3s
    const timer = setInterval(async function () {
      tries++;
      let keep = false;
      try {
        keep = await pollOnce();
      } catch (e) {}
      if (!keep || tries >= maxTries) clearInterval(timer);
    }, 3000);
    // First tick soon
    setTimeout(function () {
      pollOnce().catch(function () {});
    }, 800);
  })();
});